<div class="context-box">
    <div class="progress"><mat-progress-bar mode="indeterminate" *ngIf="(loading$ | async)"></mat-progress-bar></div>

    <div class="title">Notizen</div>

    <input type="search" placeholder="Suche" ngModel (ngModelChange)="queryChanged($event)" />
    <div #noteScrollContainer style="max-height:40vh;overflow: auto;" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="onScroll()">
        <div *ngFor="let note of (notes$ | async)" class="mb-2">
            <app-note (deleted)="noteDeleted($event)" [note]="note"></app-note>
        </div>
    </div>

    <div class="mt-3">
        <app-note-form [(ngModel)]="newNote" (noteSubmitted)="addNote($event)"></app-note-form>
    </div>
</div>
